import React from "react";
import OurMission from "../components/school/OurMissionSchool";
import PlanForSchools from "../components/school/PlanForSchools";
import SchoolGraphic from "../components/school/SchoolGraphic";
import WhyPartnerWithUs from "../components/school/WhyPartnerWithUs";
import ContactUs from "../components/ContactUs";
import WhyThisMatters from "../components/parents/WhyThisMatters";

const SchoolPage = () => {
  return (
    <>
      <div id="home">
        <PlanForSchools />
      </div>

      <WhyThisMatters />

      <div id="services">
        <SchoolGraphic />
      </div>

      <div id="why-choose-us">
        <WhyPartnerWithUs />
      </div>

      <div id="mission">
        <OurMission />
      </div>
      <div id="contact">
        <ContactUs />
      </div>
    </>
  );
};

export default SchoolPage;
